var _defs, _rect, _path, _rect2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #662d89;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.1,
    y: 0.1,
    width: 99.8,
    height: 99.8,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.3,69.01h-9.27s-.16-.15-.16-.16v-17.37c0-.63-.52-2.43-.83-3.02-1.16-2.21-4.14-2.46-6.25-1.66-3.08,1.17-3.15,4.95-3.24,7.75-.16,4.81.13,9.65,0,14.46h-9.33v-30.12h9v4.07l.88-1.26c2.5-2.98,6.25-3.89,10.02-3.45,6.21.72,8.52,4.73,9.07,10.6.25,6.71.05,13.45.11,20.17Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 30.97,
    y: 38.88,
    width: 9.44,
    height: 30.12
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 35.73,
    cy: 29.38,
    rx: 5.44,
    ry: 5.46
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInTheme);
export default __webpack_public_path__ + "static/media/linkedIn_theme.373e35401c28f5096404e32457772543.svg";
export { ForwardRef as ReactComponent };